import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from '@angular/material/icon';

// Layout module

@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule
    ]
})
export class CommonSharedModule { }
